import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { vehicleValidationForm } from "../../../utils/validationSchema";
import Form from "../../../layouts/Form";
import ServiceTypeForm from "./VehicleForm";

const CreateVehicle = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<any>({
    resolver: yupResolver(vehicleValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <ServiceTypeForm
        errors={errors}
        register={register}
      />
    </Form>
  );
};

export default CreateVehicle;
